import script from "./resetPwd.vue?vue&type=script&lang=ts&setup=true"
export * from "./resetPwd.vue?vue&type=script&lang=ts&setup=true"

import "./resetPwd.vue?vue&type=style&index=0&id=5b7162de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b7162de"]])

export default __exports__